import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "fixed z-100 inset-0 overflow-y-auto" };
const _hoisted_2 = { class: "grid place-items-center w-screen h-screen px-4 text-center sm:block sm:p-0" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", { class: "absolute inset-0 bg-gray-500 opacity-75" }, null, -1);
const _hoisted_4 = [
    _hoisted_3
];
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("span", {
    class: "hidden sm:inline-block sm:align-middle sm:h-screen z-100",
    "aria-hidden": "true"
}, null, -1);
const _hoisted_6 = {
    class: "inline-block bg-white rounded-lg text-left shadow-xl transform transition-all mobile:max-w-xs max-w-3xl md:w-3/4 align-middle",
    role: "dialog",
    "aria-modal": "true"
};
const _hoisted_7 = { class: "flex flex-col px-6 py-4 w-full" };
const _hoisted_8 = { class: "text-primary text-2xl font-bold truncate" };
const _hoisted_9 = { class: "bg-white mb-4 rounded-b-lg" };
const _hoisted_10 = { class: "bg-white mb-4 rounded-b-lg" };
const _hoisted_11 = {
    key: 0,
    class: "py-3 px-6 rounded-b-lg flex bg-gray-50 flex-row-reverse"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", {
                        class: "fixed inset-0 transition-opacity",
                        "aria-hidden": "true",
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.close()))
                    }, _hoisted_4),
                    _hoisted_5,
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("h1", _hoisted_8, [
                                _renderSlot(_ctx.$slots, "header")
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                            _renderSlot(_ctx.$slots, "default")
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                            _renderSlot(_ctx.$slots, "content")
                        ]),
                        (_ctx.$slots.actions)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                _renderSlot(_ctx.$slots, "actions")
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ])
            ])
        ]),
        _: 3
    }));
}
